import { ActivatedRouteSnapshot } from '@angular/router';

export const getChildrenRoutes = (children: ActivatedRouteSnapshot[]): ActivatedRouteSnapshot[] => {
    let nestedChildren: ActivatedRouteSnapshot[] = [];

    children.forEach((child) => {
        nestedChildren = [...nestedChildren, child, ...getChildrenRoutes(child.children)];
    });

    return nestedChildren;
};
